import React, {useState, useEffect, useMemo} from 'react'
import styled from 'styled-components';
import PayeeCard from './PayeeCard';
import { useSelector } from 'react-redux';

const Container = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    background: rgb(238,174,202);
    background: radial-gradient(circle, 
                                rgba(238,174,202,1) 0%, 
                                rgba(148,187,233,1) 100%);

`

const Header = styled.h1`
    flex: 1;
`

const ViewAllLink = styled.h1`
    flex: 1;
    border: 1px solid gray;
    border-radius: 10px;
    font-size: 20px;
    padding: 5px 20px;
    margin: 5px;
    cursor: pointer;
    background-color: black;
    color: white;
    &:hover{
        background-color: white;
        color: black;
    }
    visibility: ${props => props.show ? 'visible' : 'hidden'};
`

const CardsContainer = styled.div`
    display: flex;
    align-items: center;
    /*justify-content: space-around;*/
    gap: 10px;
    flex-wrap: wrap;
`

const SearchFilterInput = styled.input`
    visibility: ${props => props.show ? 'visible' : 'hidden'};
    
    height: 20px;
    /*width: 50%;*/
    padding: 10px;
    font-size: 20px;
    border-radius: 5px;

`

const SearchNotFound = styled.div`
    
    height: 20px;
    /*width: 50%;*/
    padding: 10px;
    color: red;
    font-size: 20px;
    visibility: ${props => props.show ? 'visible' : 'hidden'};
`

const ViewPayees = ({limit}) => {

    const [limitNo, setLimitNo] = useState(limit ? Number(limit) : 0);
    const [payeeListFiltered, setPayeeListFiltered] = useState([]);
    const [searchFilter, setSearchFilter] = useState('');
    const [filterMsg, setFilterMsg] = useState('');
    const payeeRedux = useSelector(state => state.payeeRedux);
    const payeeList = useMemo(() => [...payeeRedux?.payees], [payeeRedux?.payees]);
    payeeList.reverse();

   

    useEffect(() => {
        console.log('limit use effect');

        if(searchFilter && searchFilter.length > 0){
            const searchFilterData = payeeList?.filter((item) => (
                item.payeeName.toLowerCase()
                    .includes(searchFilter.toLowerCase()) ||
                    item.payeeDesc.toLowerCase()
                    .includes(searchFilter.toLowerCase()) ||
                    item.payeeBank.toLowerCase()
                    .includes(searchFilter.toLowerCase()) ||
                    item.payeeAcct.toLowerCase()
                    .includes(searchFilter.toLowerCase()) ||
                    item.payeeOwner.toLowerCase()
                    .includes(searchFilter.toLowerCase())
            ));

            if(limitNo > 0){
                const filterList = searchFilterData.slice(0, limitNo);
                setPayeeListFiltered(filterList);
            }
            else{
                setPayeeListFiltered(searchFilterData);
            }
            
            
        }
        else{
            if(limitNo > 0){
                const filterList = payeeList.slice(0, limitNo);
                setPayeeListFiltered(filterList);
            }
            else{
                setPayeeListFiltered(payeeList);
            }
            
        }
        
    }, [limitNo, payeeList, searchFilter]);

    useEffect(() => {
        searchFilter?.length > 0 
            ? setFilterMsg(`${payeeListFiltered.length > 0 ? payeeListFiltered.length : 'No'} Results Found`) 
            : setFilterMsg('');
    }, [payeeListFiltered, searchFilter])

   
    return (
        <Container>
            <Header>
                {(limitNo && limitNo > 0) ? 'Recent Payees' : 'All Payees' }
            </Header>

            <SearchFilterInput 
                show={!limitNo || limitNo === 0}
                placeholder='Search'
                onChange={(e) => setSearchFilter(e.target.value)}>
            </SearchFilterInput>
                
            <SearchNotFound show={filterMsg}>
                {filterMsg}
            </SearchNotFound> 

            <CardsContainer>
                {payeeListFiltered.map((item, index) => (
                    <PayeeCard key={index} payee={item} />
                ))}
            </CardsContainer>
            <ViewAllLink show={limitNo && limitNo > 0} 
                            onClick={() => setLimitNo(0)}>
                Click To View All
            </ViewAllLink>
            
        </Container>
    )
}

export default ViewPayees
